import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const occupationEntityName = 'occupation';
export const occupationColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { groupId: {
        type: 'id',
        index: true,
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
